module.exports = __webpack_public_path__ + "img/ig-verify-2.31d34d8f.svg";